import api from "./axios";

// Public
export const getCourses = (params) =>
  api.get("/api/courses/", { params });

export const getCourse = (slug) =>
  api.get(`/api/courses/${slug}/`);

// Admin
export const adminGetCourses = (params = {}) =>
  api.get("/api/admin/courses/", { params });

export const adminCreateCourse = (formData) =>
  api.post("/api/admin/courses/", formData, {
    headers: { "Content-Type": undefined }, // let axios/browser set the multipart boundary
  });

export const adminUpdateCourse = (id, formData) =>
  api.put(`/api/admin/courses/${id}/`, formData, {
    headers: { "Content-Type": undefined },
  });

export const adminDeleteCourse = (id) =>
  api.delete(`/api/admin/courses/${id}/`);

export const adminGetCourseById = (id) =>
  api.get(`/api/admin/courses/${id}/`);